<template>
	<v-container fluid>
		<v-row style="margin-top: 0px !important; padding: 0 50px">
			<v-col cols="12" md="6" sm="6" class="">
				<router-link to="/beneficius">
					<v-img
						class=""
						src="../assets/beneficius/logobeneficius.png"
						width="150"
						contain
					></v-img>
				</router-link>
			</v-col>

			<v-col cols="12" md="6" sm="6" class="d-flex align-end justify-end">
				<router-link to="/beneficius">
					<v-btn class="btnMenu">Home</v-btn>
				</router-link>
				<v-btn class="btnMenu">Sobre nós</v-btn>
				<v-btn class="btnMenu">Ajuda</v-btn>
			</v-col>
		</v-row>
		<v-divider class="mx-4 mt-5"></v-divider>
		<v-row style="padding: 0 50px">
			<v-col cols="12" md="12">
				<div class="historyMenu">
					Home | Hospedagem | Mércuri Barra da Tijuca
				</div>
			</v-col>
		</v-row>

		<v-row style="padding: 50px">
			<v-col cols="12" md="8">
				<v-card-title
					style="
						padding: 0px;
						font-family: raleway;
						color: #042d4c;
						font-weight: 700;
					"
					>Cafe Badilico</v-card-title
				>

				<p style="padding: 0px; font-family: raleway; color: #91a3b0">
					<v-icon color="orange">mdi-map-marker</v-icon>
					Rio de Janeiro, Brazil, A 14,79 k
				</p>
				<v-card-text style="padding: 0px">
					<v-row align="center" class="mx-0">
						<v-rating
							:value="4.5"
							color="amber"
							dense
							half-increments
							readonly
							size="14"
						></v-rating>

						<div class="grey--text ms-4">4.5 (413)</div>
					</v-row>
				</v-card-text>
			</v-col>
			<v-col cols="12" md="4" class="alinhadoM">
				<div
					style="margin-right: 15px"
					class="etiqueta d-flex justify-center align-center"
				>
					<span style="color: #042d4c">até 100% em Ribus Token</span>
				</div>
			</v-col>
			<v-col cols="6" md="7">
				<v-img
					height="100%"
					src="../assets/beneficius/casa1.png"
				></v-img>
			</v-col>
			<v-col cols="6" md="5" class="flex-column d-flex justify-center">
				<h2
					style="
						padding: 0px;
						font-family: raleway;
						color: #042d4c;
						font-weight: 700;
					"
				>
					Conheça nosso parceiro de hospedagem
				</h2>

				<p
					style="
						font-family: raleway;
						font-weight: 300;
						color: #042d4c;
					"
				>
					Entre em contato com nossa pousada parceira e use suas Ribus
					para pagar sua estadia.
				</p>

				<v-divider class="mx-4"></v-divider>

				<v-card-actions class="" style="padding: 20px 0">
					<router-link to="/beneficiusDescriImovel">
						<v-btn
							style="
								border: 1px solid #fe9a29;
								color: #fe9a29;
								box-shadow: none;
								background-color: transparent;
							"
						>
							Faça sua reserva
						</v-btn>
					</router-link>
				</v-card-actions>
			</v-col>
		</v-row>

		<v-divider class="mx-4"></v-divider>

		<v-row style="padding: 50px">
			<v-col cols="12" md="12">
				<h2
					style="
						padding: 0px;
						font-family: raleway;
						color: #042d4c;
						font-weight: 700;
					"
				>
					Sobre:
				</h2>

				<p
					class="mt-10"
					style="
						font-family: raleway;
						font-weight: 400;
						color: #042d4c;
					"
				>
					Nossas acomodações são aconchegantes, possuem
					Ar-condicionado, SmartTV com Netflix e WIFI ultrarrápido.
					<br />
					<br />
					Cada Cabana é equipada com cama box com colchão premium e
					sofá cama, além de uma cozinha completa com cooktop,
					geladeira e demais utensílios. Temos um quiosque com
					Ar-condicionado, SmartTV com Netflix e WIFI ultrarrápido.
					churrasqueira compartilhada junto com espetos e grelha.
					<br />
					<br />
					Disponibilizamos uma área externa com piscina, jardim e
					redário. <br />
					<br />
					Oferecemos uma deliciosa cesta de café da manhã entregue
					todos os dias no seu chalé R$ 30,00 p/2 pessoas
				</p>
			</v-col>



			<v-col cols="12" md="6">
				<h2
					style="
						padding: 0px;
						font-family: raleway;
						color: #042d4c;
						font-weight: 700;
					"
				>
                O que oferecemos
				</h2>
                <div class="d-flex">
                    <v-list dense>
                        <v-list-item-group v-model="selectedItem1" color="primary">
                            <v-list-item v-for="(item, i) in items" :key="i">
                                <v-list-item-icon >
                                    <v-icon color="#FE9A29" v-text="item.icon"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title  style=" padding: 0px; font-family: raleway; color: #042D4C; font-weight: 600; "
                                        v-text="item.text"
                                    ></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>

                    <v-list dense>
                        <v-list-item-group v-model="selectedItem2" color="primary">
                            <v-list-item v-for="(item2, i) in items2" :key="i">
                                <v-list-item-icon >
                                    <v-icon color="#FE9A29" v-text="item2.icon"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title  style=" padding: 0px; font-family: raleway; color: #042D4C; font-weight: 600; "
                                        v-text="item2.text"
                                    ></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
            </div>
			</v-col>
			<v-col cols="12" md="6">
                <h2
					style="
						padding: 0px;
						font-family: raleway;
						color: #042d4c;
						font-weight: 700;
					"
				>
                Contatos:
				</h2>
                    <v-list dense>
                        <v-list-item-group v-model="selectedItem3" color="primary">
                            <v-list-item v-for="(item3, i) in items3" :key="i">
                                <v-list-item-icon >
                                    <v-icon color="#FE9A29" v-text="item3.icon"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title  style=" padding: 0px; font-family: raleway; color: #042D4C; font-weight: 600; "
                                        v-text="item3.text"
                                    ></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
            </v-col>
		</v-row>

        <v-row class="footerBeneficius" v-if="intBreakPoint >= 2">
			<v-col cols="12" md="4">
				<img src="../assets/beneficius/logobranco.png" alt="" />
				<p
					class="mt-10"
					style="font-family: raleway; font-weight: 300; color: #fff"
				>
					O clube de vantagens oficial da Ribus para Tokenistas.
				</p>
				<div>
					<a href="https://www.facebook.com/ribusdigital/" target="_blank">
						<v-icon color="#fff" size="30" style="margin: 0 5px"
							>mdi-facebook</v-icon
						>
					</a>
					<a href="https://www.instagram.com/ribusdigital/" target="_blank">
						<v-icon color="#fff" size="30" style="margin: 0 5px"
							>mdi-instagram</v-icon
						>
					</a>
					<a
						href="https://www.linkedin.com/company/ribus-tecnologia/"
						target="_blank"
					>
						<v-icon color="#fff" size="30" style="margin: 0 5px"
							>mdi-linkedin</v-icon
						>
					</a>
				</div>
			</v-col>
			<v-col cols="6" md="4">
				<h3 style="font-family: raleway; font-weight: 500; color: #fff">
					Mapa do site
				</h3>

				<a href="/beneficius" style="color: #fff; text-decoration: none">
					<p
						class="mt-10"
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Home
					</p>
				</a>
				<a href="#sobre" style="color: #fff; text-decoration: none">
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Sobre nós
					</p>
				</a>

				<a href="#ajuda" style="color: #fff; text-decoration: none">
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Ajuda
					</p>
				</a>

				<a
					href="https://ribus.com.br/docs/Politica-de-Privacidade.pdf"
					target="_blank"
					style="color: #fff; text-decoration: none"
				>
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Política de privacidade
					</p>
				</a>
			</v-col>
			<v-col cols="6" md="4">
				<h3 style="font-family: raleway; font-weight: 500; color: #fff">
					Nossos serviços
				</h3>
				<a href="/beneficius" style="color: #fff; text-decoration: none">
					<p
						class="mt-10"
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Home
					</p>
				</a>
				<a
					href="/beneficiusParceiros"
					style="color: #fff; text-decoration: none"
				>
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Parceiros
					</p>
				</a>
				<a
					href="/beneficiusHospedagens"
					style="color: #fff; text-decoration: none"
				>
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Hospedagem
					</p>
				</a>
				<a href="tel:+552199999999" style="color: #fff; text-decoration: none">
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						<v-icon color="white">mdi-book</v-icon>
						+55 21 9999-9999
					</p>
				</a>
				<a
					href="mailto:contato@beneficiuscombr"
					style="color: #fff; text-decoration: none"
				>
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						<v-icon color="white">mdi-at</v-icon>
						contato@beneficiuscombr
					</p>
				</a>
			</v-col>
		</v-row>

		<v-row class="footerBeneficius d-flex" v-else>
			<v-col cols="12" md="4">
				<img src="../assets/beneficius/logobranco.png" alt="" />
				<p
					class="mt-10"
					style="font-family: raleway; font-weight: 300; color: #fff"
				>
					O clube de vantagens oficial da Ribus para Tokenistas.
				</p>
				<div>
					<a href="https://www.facebook.com/ribusdigital/" target="_blank">
						<v-icon color="#fff" size="30" style="margin: 0 5px"
							>mdi-facebook</v-icon
						>
					</a>
					<a href="https://www.instagram.com/ribusdigital/" target="_blank">
						<v-icon color="#fff" size="30" style="margin: 0 5px"
							>mdi-instagram</v-icon
						>
					</a>
					<a
						href="https://www.linkedin.com/company/ribus-tecnologia/"
						target="_blank"
					>
						<v-icon color="#fff" size="30" style="margin: 0 5px"
							>mdi-linkedin</v-icon
						>
					</a>
				</div>
			</v-col>
			<v-col cols="12" md="4">
				<h3 style="font-family: raleway; font-weight: 500; color: #fff">
					Mapa do site
				</h3>

				<a href="/beneficius" style="color: #fff; text-decoration: none">
					<p
						class="mt-10"
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Home
					</p>
				</a>
				<a href="#sobre" style="color: #fff; text-decoration: none">
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Sobre nós
					</p>
				</a>

				<a href="#ajuda" style="color: #fff; text-decoration: none">
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Ajuda
					</p>
				</a>

				<a
					href="https://ribus.com.br/docs/Politica-de-Privacidade.pdf"
					target="_blank"
					style="color: #fff; text-decoration: none"
				>
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Política de privacidade
					</p>
				</a>
			</v-col>
			<v-col cols="12" md="4">
				<h3 style="font-family: raleway; font-weight: 500; color: #fff">
					Nossos serviços
				</h3>
				<a href="/beneficius" style="color: #fff; text-decoration: none">
					<p
						class="mt-10"
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Home
					</p>
				</a>
				<a
					href="/beneficiusParceiros"
					style="color: #fff; text-decoration: none"
				>
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Parceiros
					</p>
				</a>
				<a
					href="/beneficiusHospedagens"
					style="color: #fff; text-decoration: none"
				>
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						Hospedagem
					</p>
				</a>
				<a href="tel:+552199999999" style="color: #fff; text-decoration: none">
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						<v-icon color="white">mdi-book</v-icon>
						+55 21 9999-9999
					</p>
				</a>
				<a
					href="mailto:contato@beneficiuscombr"
					style="color: #fff; text-decoration: none"
				>
					<p
						style="
							font-family: raleway;
							font-weight: 300;
							color: #fff;
							margin: 5px 0;
						"
					>
						<v-icon color="white">mdi-at</v-icon>
						contato@beneficiuscombr
					</p>
				</a>
			</v-col>
		</v-row>
	</v-container>
</template>

<style scoped>
.footerBeneficius {
		background-color: #042d4c;
		padding: 50px;
	}
	.etiqueta {
		background-color: #28e78e;
		padding: 4px 8px;
		border-radius: 16px;
		/* height: 30px; */
		/* width: 193px; */
		margin: 11px 0;
	}

	.historyMenu {
		font-family: raleway;
		color: #042d4c;
		font-weight: 500;
	}
	.btnMenu {
		background-color: transparent !important;
		box-shadow: none !important;
		color: #4d6a80 !important;
	}
</style>


<script>
  export default {
    data: () => ({
      selectedItem: 1,
      items: [
        { text: 'Cozinha', icon: 'mdi-stove' },
        { text: 'Estacionamento incluído', icon: 'mdi-car-estate' },
        { text: 'Permitido animais', icon: 'mdi-paw' },
        { text: 'Ar-condicionado', icon: 'mdi-air-filter' },
      ],

      items2: [
        { text: 'Wi-Fi', icon: 'mdi-wifi' },
        { text: 'Piscina', icon: 'mdi-swim' },
        { text: 'TV', icon: 'mdi-television-classic' },
        { text: 'Secador de cabelo', icon: 'mdi-hair-dryer-outline' },
      ],
      items3: [
        { text: '+55 21 9999-9999', icon: 'mdi-whatsapp' },
        { text: '+55 21 9999-9999', icon: 'mdi-phone-dial-outline' },
        { text: 'contato@vcadvogados.com.br', icon: 'mdi-at' },
      ],
    }),

    mounted() {
			window.scrollTo(0, 0);
		},
  }
</script>